(() => {
  function initialiseContactForm() {
    const form = document.getElementById(
      "cs-intelligent-contact-form"
    );

    if (!form) return;

    const typeSelect = form.querySelector(
      "[data-cs-contact-type]"
    );

    const customFields = form.querySelector(
      "[data-cs-contact-custom-fields]"
    );

    const deliveryFields = form.querySelector(
      "[data-cs-contact-delivery-fields]"
    );

    const returnFields = form.querySelector(
      "[data-cs-contact-return-fields]"
    );

    const colourInput = form.querySelector(
      "[data-cs-contact-colour]"
    );

    const productInput = form.querySelector(
      "[data-cs-contact-product]"
    );

    const originInput = form.querySelector(
      "[data-cs-contact-origin]"
    );

    const sourceInput = form.querySelector(
      "[data-cs-contact-source]"
    );

    const context = form.querySelector(
      "[data-cs-contact-context]"
    );

    const contextTitle = form.querySelector(
      "[data-cs-contact-context-title]"
    );

    const contextColour = form.querySelector(
      "[data-cs-contact-context-colour]"
    );

    const contextColourValue = form.querySelector(
      "[data-cs-contact-context-colour-value]"
    );

    if (
      !typeSelect ||
      !customFields ||
      !deliveryFields ||
      !returnFields
    ) {
      return;
    }

    const params = new URLSearchParams(
      window.location.search
    );

    const requestType = params.get("request");
    const intent = params.get("intent");

    const colourParameter =
      params.get("colour") || "";

    const productParameter =
      params.get("product") ||
      params.get("screw") ||
      "";

    let initialType = "General Enquiry";
    let source = "Direct Contact Page";
    let contextHeading = "";

    if (
      requestType === "custom-screw" ||
      requestType === "custom-colour"
    ) {
      initialType =
        "Custom Colour Or Screw Request";

      source =
        requestType === "custom-screw"
          ? "Colour Page – Custom Screw"
          : "Colour Page – Custom Colour";

      contextHeading =
        requestType === "custom-screw"
          ? "Order This Colour On Another Screw"
          : "Request A Custom Colour";
    } else if (
      intent === "custom-colour-sample" ||
      requestType === "sample"
    ) {
      initialType = "Sample";
      source = "Sample Page";
      contextHeading = "Request A Sample";
    } else if (requestType === "delivery-issue") {
      initialType = "Delivery Issue";
      source = "Delivery Issue Link";
    } else if (
      requestType === "refund" ||
      requestType === "return"
    ) {
      initialType = "Refund Or Return";
      source = "Refund Or Return Link";
    }

    function cleanParameter(value, maximumLength) {
      return value
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, maximumLength);
    }

    const selectedColour = cleanParameter(
      colourParameter,
      100
    );

    const selectedProduct = cleanParameter(
      productParameter,
      150
    );

    function setSectionState(
      section,
      shouldShow
    ) {
      section.hidden = !shouldShow;

      section
        .querySelectorAll(
          "input, select, textarea"
        )
        .forEach((field) => {
          field.disabled = !shouldShow;
        });
    }

    function updateForm(type) {
      const showCustomFields =
        type ===
          "Custom Colour Or Screw Request" ||
        type === "Sample";

      const showDeliveryFields =
        type === "Delivery Issue";

      const showReturnFields =
        type === "Refund Or Return";

      setSectionState(
        customFields,
        showCustomFields
      );

      setSectionState(
        deliveryFields,
        showDeliveryFields
      );

      setSectionState(
        returnFields,
        showReturnFields
      );

      const hasAutomaticContext =
        Boolean(contextHeading);

      if (
        context &&
        contextTitle
      ) {
        if (hasAutomaticContext) {
          contextTitle.textContent =
            contextHeading;

          context.hidden = false;
        } else {
          context.hidden = true;
        }
      }

      if (
        contextColour &&
        contextColourValue
      ) {
        if (
          hasAutomaticContext &&
          selectedColour
        ) {
          contextColourValue.textContent =
            selectedColour;

          contextColour.hidden = false;
        } else {
          contextColour.hidden = true;
        }
      }
    }

    typeSelect.value = initialType;

    if (colourInput && selectedColour) {
      colourInput.value = selectedColour;
    }

    if (productInput && selectedProduct) {
      productInput.value = selectedProduct;
    }

    if (originInput) {
      originInput.value =
        document.referrer ||
        window.location.href;
    }

    if (sourceInput) {
      sourceInput.value = source;
    }

    updateForm(initialType);

    typeSelect.addEventListener(
      "change",
      () => {
        contextHeading = "";

        if (sourceInput) {
          sourceInput.value =
            `Contact Page – ${typeSelect.value}`;
        }

        updateForm(typeSelect.value);
      }
    );

    /*
     * Remove blank optional conditional fields
     * from the submitted Shopify email.
     */

    form.addEventListener("submit", () => {
      const conditionalSections = [
        customFields,
        deliveryFields,
        returnFields
      ];

      conditionalSections.forEach(
        (section) => {
          section
            .querySelectorAll(
              "input, select, textarea"
            )
            .forEach((field) => {
              if (field.disabled) return;

              if (!field.value.trim()) {
                field.disabled = true;
              }
            });
        }
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseContactForm
    );
  } else {
    initialiseContactForm();
  }
})();